import { z } from 'zod';

import { FORGOT_PASSWORD_ERROR } from '../shared';

/** Zod schema for `/auth/forgot-password` URL search params. */
export const forgotPasswordSearchSchema = z.object({
  /** Pre-fill the email field (e.g. carried over from the login form). */
  email: z.string().email().optional().catch(undefined),
  /** Discriminator passed when another flow redirects here (e.g. reset-password on an expired code). */
  error: z.nativeEnum(FORGOT_PASSWORD_ERROR).optional().catch(undefined)
});

export type ForgotPasswordSearch = z.infer<typeof forgotPasswordSearchSchema>;
